<template>
  <div class="h-80px flex">
    <div :key="index" v-for="(item, index) in data" class="flex-auto flex items-center ">
      <div class="flex-auto flex  justify-center">
        <i
          class="p-10px iconfont icon-bg-examinationUnit text-50px mx-20px text-white rounded"
          :class="item.iconName"
          :style="{ background: item.bgColor, color: item.color }"
        ></i>
        <div class="pr-20px flex flex-col justify-between">
          <span :style="{ color: item.color }" class="font-bold text-18px">
            {{ item.value + (item.unit || '') }}</span
          >
          <p class="text-trueGray-400">{{ item.label }}</p>
        </div>
      </div>
      <div class="h-52px w-1px border-1px boder-color-default" v-if="index < data.length - 1"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'kpi-list',
  props: {
    data: {
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss"></style>
